import React from 'react';
import { useForm } from 'react-hook-form';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import InputWrapper from '../../../../Components/Form/components/InputWrapper/InputWrapper';
import InputField from '../../../../Components/Form/components/InputField';
import TextAreaField from '../../../../Components/Form/components/TextAreaField';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import { FormValues } from '../../../MagicForm/Interfaces/FormValues';
import apiClient from '../../../../Services/ApiClient';
import useApiClient from '../../../Base/Hooks/useApiClient';
import useNotification from '../../../../Hooks/useNotification.hook';
import useTranslation from '../../../../Hooks/useTranslation';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

interface Props {
	onSuccess: () => void;
	group: {
		id: string;
		name: string;
		description?: string;
	};
}

const validationScheme = yup.object({
	name: yup.string().required('validation.patientsGroupsRename.name'),
	description: yup
		.string()
		.max(255, 'validation.patientsGroupsRename.description')
		.notRequired(),
});

const PatientsGroupsRename: React.FC<Props> = ({ group, onSuccess }) => {
	const { displayError } = useApiClient();
	const { showNotificationSuccess } = useNotification();
	const { t } = useTranslation();
	const formMethods = useForm({
		defaultValues: group,
		resolver: yupResolver(validationScheme),
	});

	const handleSubmit = async (values: FormValues) => {
		try {
			const result = await apiClient.patch(`/group/${group.id}`, values);
			if (result) {
				showNotificationSuccess({
					content: t('component.groupMsgs.groupEdited'),
				});
			}
		} catch (e) {
			displayError(e);
		}
		onSuccess();
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<InputWrapper>
				<InputField name='name' label='base.groupName' isRequired />
			</InputWrapper>
			<InputWrapper>
				<TextAreaField
					name='description'
					label='base.groupDescription'
					charactersLimit={255}
					showCharCounter
				/>
			</InputWrapper>
			<SubmitButton onSubmit={handleSubmit} title='base.editGroup' />
		</FormWrapper>
	);
};

export default PatientsGroupsRename;
